<div class="h-screen bg-primary flex items-center justify-center">
  <div class="w-4/12 text-center">
    <h2 class="text-white m-0">Tour Operations System</h2>
    <button class="mt-8" nz-button nzType="default" routerLink="/auth">
      explore app
    </button>
  </div>
</div>
